import * as actions from '../constants/operations_action_types.jsx';
import * as api from '../constants/operations_api.jsx';
import i18n, { getIso } from '../utils/localizations.jsx'
import { request_helper } from "./request_helper.js";
import {utils} from "../utils/utils";

export const actionOperations = {
    getOperations: (filter) => async (dispatch, getState) => {
        dispatch({ type: actions.START_REQUEST });
        const url = api.GET_OPERATIONS_LIST_API;

        const postData = {
            pageNumber: filter.pagesFilter.currentPage,
            modelFilter: filter.modelFilter,
            sortFilter: filter.sortFilter
        }

        try {
            const data = await request_helper.callWithDispatch(dispatch, "POST", url, postData);
            let operations = {
                items: data.items,
                filter: {
                    pagesFilter: { currentPage: data.currentPage, pageCount: data.pagesCount, maxItemsOnPage: data.maxItemsOnPage },
                    modelFilter: filter.modelFilter,
                    sortFilter: filter.sortFilter
                }
            }
            dispatch({ type: actions.GET_OPERATIONS, operations });
        }
        catch (error) {
            dispatch({ type: actions.END_REQUEST });
        }
    },
    getReport: () => async (dispatch, getState) => {
        dispatch({ type: actions.START_REQUEST });
        const url = api.GET_OPERATIONS_REPORT_API;

        const filter = getState().operations.filter;
        const postData = {
            pageNumber: filter.pagesFilter.currentPage,
            modelFilter: filter.modelFilter,
            sortFilter: {}
        }

        try {
            const response = await request_helper.callWithDispatchReport(dispatch, "POST", url, postData);
            dispatch({ type: actions.END_REQUEST });
            return response;
        }
        catch (error) {
            dispatch({ type: actions.END_REQUEST });
        }
    }
};
